import { cn } from '@/core/utils/common'
import { formatWon } from '@/features/site/config'

type ProductPriceProps = {
  price: number
  listPrice: number | null
  discountRate: number
  size?: 'card' | 'detail'
  className?: string
}

export default function ProductPrice({
  price,
  listPrice,
  discountRate,
  size = 'card',
  className,
}: ProductPriceProps) {
  const discounted = discountRate > 0 && listPrice !== null && listPrice > price
  const isDetail = size === 'detail'

  return (
    <div className={className}>
      {discounted && isDetail && (
        <p className="type-ui tabular-nums text-description line-through">
          {formatWon(listPrice)}
        </p>
      )}
      <p
        className={cn(
          'flex flex-wrap items-baseline gap-x-1.5 font-bold tabular-nums',
          isDetail
            ? 'text-c28 over10:text-c36'
            : 'text-c17 leading-[1.3] over10:text-c20'
        )}
      >
        {discounted && <span className="text-point">{discountRate}%</span>}
        <span>{formatWon(price)}</span>
        {discounted && !isDetail && (
          <span className="text-c13 font-normal text-description line-through over10:text-c14">
            {formatWon(listPrice)}
          </span>
        )}
      </p>
    </div>
  )
}
